(function () {
  var root = document.querySelector('[data-get-in-touch]');
  if (!root) return;

  var toggle = root.querySelector('.get-in-touch__toggle');
  var menu = root.querySelector('.get-in-touch__menu');
  var chatButton = root.querySelector('[data-get-in-touch-chat]');
  var callLink = root.querySelector('[data-get-in-touch-call]');
  var callPhone = root.querySelector('[data-get-in-touch-call-phone]');
  var callNote = root.querySelector('[data-get-in-touch-call-note]');

  function melbourneMinutes() {
    var parts = new Intl.DateTimeFormat('en-AU', {
      timeZone: 'Australia/Melbourne',
      hour: 'numeric',
      minute: 'numeric',
      hourCycle: 'h23'
    }).formatToParts(new Date());
    var hour = 0;
    var minute = 0;
    parts.forEach(function (part) {
      if (part.type === 'hour') hour = Number(part.value);
      if (part.type === 'minute') minute = Number(part.value);
    });
    return hour * 60 + minute;
  }

  function updateCallState() {
    if (!callLink) return;
    var open = melbourneMinutes() >= 10 * 60 && melbourneMinutes() < 18 * 60;
    callLink.classList.toggle('is-unavailable', !open);
    callLink.setAttribute('aria-disabled', open ? 'false' : 'true');
    if (callPhone) callPhone.hidden = !open;
    if (callNote) callNote.hidden = open;
    if (!open) callLink.removeAttribute('href');
    else callLink.setAttribute('href', 'tel:+61393998883');
  }

  function setMenuOpen(open) {
    if (!toggle || !menu) return;
    menu.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  var launcherStyle = [
    'button.activator,',
    '.activator,',
    'button.chat-toggle,',
    '.chat-toggle,',
    '#dummy-chat-button,',
    '[class*="launcher"],',
    '[class*="Launcher"] {',
    'display: none !important;',
    'background: transparent !important;',
    'background-color: transparent !important;',
    'background-image: none !important;',
    'box-shadow: none !important;',
    'border: 0 !important;',
    'width: 0 !important;',
    'height: 0 !important;',
    'min-width: 0 !important;',
    'min-height: 0 !important;',
    'padding: 0 !important;',
    'margin: 0 !important;',
    'opacity: 0 !important;',
    'visibility: hidden !important;',
    'pointer-events: none !important;',
    'overflow: hidden !important;',
    '}'
  ].join('');

  function eachRoot(callback) {
    var roots = [document];
    function walk(root) {
      root.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot) {
          roots.push(el.shadowRoot);
          walk(el.shadowRoot);
        }
      });
    }
    walk(document);
    roots.forEach(callback);
  }

  function clearChrome(el) {
    el.style.setProperty('background', 'transparent', 'important');
    el.style.setProperty('background-color', 'transparent', 'important');
    el.style.setProperty('background-image', 'none', 'important');
    el.style.setProperty('box-shadow', 'none', 'important');
    el.style.setProperty('border-color', 'transparent', 'important');
  }

  function collapseLauncher(el) {
    clearChrome(el);
    el.style.setProperty('display', 'none', 'important');
    el.style.setProperty('border', '0', 'important');
    el.style.setProperty('width', '0', 'important');
    el.style.setProperty('height', '0', 'important');
    el.style.setProperty('min-width', '0', 'important');
    el.style.setProperty('min-height', '0', 'important');
    el.style.setProperty('padding', '0', 'important');
    el.style.setProperty('margin', '0', 'important');
    el.style.setProperty('opacity', '0', 'important');
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('pointer-events', 'none', 'important');
    el.style.setProperty('overflow', 'hidden', 'important');
  }

  function hideInboxLauncher() {
    eachRoot(function (root) {
      if (!root.querySelector || root.querySelector('style[data-hide-inbox-launcher]')) return;
      if (!root.querySelector('button.activator, .activator, button.chat-toggle, .chat-toggle, #dummy-chat-button')) return;
      var style = document.createElement('style');
      style.setAttribute('data-hide-inbox-launcher', '');
      style.textContent = launcherStyle;
      root.appendChild(style);
    });

    eachRoot(function (root) {
      root.querySelectorAll('button.activator, .activator, button.chat-toggle, .chat-toggle, #dummy-chat-button').forEach(function (el) {
        if (el.getAttribute('aria-expanded') === 'true') return;
        collapseLauncher(el);
        var parent = el.parentElement;
        if (!parent || /panel|window|conversation|transcript/i.test((parent.className || '').toString())) return;
        clearChrome(parent);
      });
    });

    document.querySelectorAll('shopify-chat, inbox-online-store-chat, shopify-agent, #ShopifyChat, #shopify-chat').forEach(clearChrome);

    document.querySelectorAll('iframe').forEach(function (iframe) {
      var hint = (
        iframe.id + ' ' +
        iframe.name + ' ' +
        iframe.title + ' ' +
        (iframe.getAttribute('src') || '')
      ).toLowerCase();
      if (!/chat|message|inbox/.test(hint)) return;
      if (!/dummy|button|launcher/.test(hint)) return;
      collapseLauncher(iframe);
    });
  }

  if (toggle) {
    toggle.addEventListener('click', function () {
      setMenuOpen(menu.hidden);
    });
  }

  document.addEventListener('click', function (event) {
    if (!root.contains(event.target)) setMenuOpen(false);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') setMenuOpen(false);
  });

  if (chatButton) {
    chatButton.addEventListener('click', function (event) {
      setMenuOpen(false);
      if (typeof openShopifyChat === 'function') openShopifyChat(event);
    });
  }

  updateCallState();
  window.setInterval(updateCallState, 60 * 1000);
  hideInboxLauncher();
  window.setInterval(hideInboxLauncher, 1000);

  var observer = new MutationObserver(hideInboxLauncher);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
